import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ChatServiceService} from '../../_services/chatService.service';

@Component({
    selector: 'app-programs',
    templateUrl: './programs.component.html',
    styleUrls: ['./programs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgramsComponent implements OnInit {

  constructor(public chatService: ChatServiceService) { }

  ngOnInit(): void {
  }

}
